import { EditorAPIKey } from '#packages/apis';
import type { EntryPoint } from '#packages/apilib';
import { createMaskCropApi } from './maskCropWrapper';
import { MaskCropApiKey } from './publicApiKey';

export const MaskCropEntrypoint: EntryPoint = {
  name: 'MaskCropApi',
  declareAPIs: () => [MaskCropApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(MaskCropApiKey, () => createMaskCropApi(shell));
  },
};
